import React from 'react'

const AlertList = () => {
  return (
    <div>AlertList</div>
  )
}

export default AlertList